var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -36.4,
    y: -36.4,
    width: 163.8,
    height: 163.8
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18.2px)",
      clipPath: "url(#bgblur_0_7581_20331_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 13.7358,
    fill: "#2783EC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8198 38.8069H48.0215V42.8923C49.203 40.5426 52.2328 38.4315 56.7842 38.4315C65.5093 38.4315 67.5807 43.1087 67.5807 51.6903V67.5837H58.7474V53.6447C58.7474 48.7576 57.5659 46.0016 54.5582 46.0016C50.3866 46.0016 48.6531 48.9718 48.6531 53.6425V67.5837H39.8198V38.8069ZM24.6728 67.2082H33.5061V38.4315H24.6728V67.2082ZM34.7715 29.0482C34.7718 29.7886 34.625 30.5217 34.3395 31.2049C34.0541 31.888 33.6357 32.5076 33.1086 33.0277C32.5801 33.5535 31.953 33.97 31.2634 34.2535C30.5738 34.5369 29.8351 34.6817 29.0895 34.6795C27.5869 34.6761 26.1456 34.0839 25.0747 33.0299C24.5498 32.5079 24.1329 31.8876 23.848 31.2044C23.563 30.5212 23.4156 29.7885 23.4141 29.0482C23.4141 27.5532 24.0103 26.1222 25.0769 25.0666C26.1451 24.0086 27.5882 23.4156 29.0917 23.417C30.5978 23.417 32.042 24.011 33.1086 25.0666C34.1753 26.1222 34.7715 27.5532 34.7715 29.0482Z",
    fill: "#2783EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7581_20331_clip_path",
    transform: "translate(36.4 36.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 13.7358
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin2);
export default __webpack_public_path__ + "static/media/icon-linkedin2.4c22c2f341c3e2e6c0fa4d18ea3bd1e3.svg";
export { ForwardRef as ReactComponent };